import React, { useEffect, useRef, useState } from 'react';
import { EditorHeader } from '../lomavisCreator/components/sharedComponents';
import { useTranslate } from '@tolgee/react';
import { getLanguage } from '../../locales/language';
import { Button } from 'react-bootstrap';
import { relocatePublishButtons } from '../lomavisCreator/utils/uploadMediaFile';
import TemplateCard from './templateCard';
import { useDispatch, useSelector } from 'react-redux';
import {
  getWhatsappTemplates,
  toggleTemplateModal
} from '../../redux/slices/whatsappTemplate';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import SendTemplate from './templateDetail';
import { OpenWhatsAppTemplateModal } from './components/OpenWhatsAppTemplateModal';
import { RedirectToWhatsAppManager } from './components/RedirectToWhatsAppManager';
import toast from 'react-hot-toast';

const WhatsappTemplate = ({ locationUUID }) => {
  const { t } = useTranslate();
  const submitRef = useRef(null);
  const dispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>();
  const footerRef = useRef(null);
  const language = getLanguage();
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const { template_data, loading_template, modal_close_event } = useSelector(
    (state: any) => state.WhatsappTemplateBuilder
  );

  const [rightMargin, setRightMargin] = useState(0);

  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      // Skip the first execution
      hasMounted.current = true;
      return;
    }

    console.log('i trigger');
    if (modal_close_event) {
      if (selectedTemplate) {
        setSelectedTemplate(null);
      } else {
        dispatch(toggleTemplateModal(false));
      }
    }
  }, [modal_close_event]);

  useEffect(() => {
    if (locationUUID) {
      dispatch(getWhatsappTemplates(`${locationUUID}`));
    }
  }, []);

  useEffect(() => {
    relocatePublishButtons({
      footerRef: footerRef,
      setRightMargin: setRightMargin
    });
  }, []);

  const onClick = (template) => {
    if (template.status == 'APPROVED') {
      setSelectedTemplate(template);
    } else {
      const k = 'communication.whatsappTemplate.templateNotApproved';
      toast.error(t(k), {
        position: 'top-right',
        id: k
      });
    }
  };

  return (
    <div className="w-100 h-100 d-flex flex-column gap-4">
      <EditorHeader>
        <div
          style={{}}
          className="d-flex flex-fill align-items-center h-100 main_editor"
        >
          {selectedTemplate ? (
            <h2>{t('whatsappTemplate.SendTemplate.header')}</h2>
          ) : (
            <h2>{t('communication.whatsappTemplate.header')}</h2>
          )}
        </div>
        <div>
          <RedirectToWhatsAppManager locationUUID={locationUUID} />
        </div>
      </EditorHeader>

      {selectedTemplate ? (
        <SendTemplate
          template={selectedTemplate}
          submitRef={submitRef}
          submitting={submitting}
          setSubmitting={setSubmitting}
        />
      ) : (
        <div
          className={
            'd-flex flex-column w-100 position-relative gap-4 rounded-3 py-3 px-2 bg-white flex-fill flex-1'
          }
          style={{ overflowY: 'auto' }}
        >
          <div
            className={
              'd-flex flex-wrap gap-3 w-100 position-relative rounded-3 p-2 justify-content-start'
            }
          >
            {loading_template ? (
              <div className="w-100 h-100 d-flex justify-content-center align-items-center ">
                <div
                  className="spinner-border text-muted"
                  role="status"
                  style={{
                    borderWidth: '5px',
                    borderRadius: '50%',
                    height: '50px',
                    width: '50px'
                  }}
                ></div>
              </div>
            ) : template_data?.length > 0 ? (
              template_data?.map((template) => (
                <div
                  key={template.id} // Ensure each item has a unique key
                  className="d-flex flex-column"
                  style={{ width: '280px' }}
                  onClick={() => onClick(template)}
                >
                  <TemplateCard template={template} cardOnly={false} />
                </div>
              ))
            ) : (
              <div className="d-flex flex-column justify-content-center w-100 h-100 align-items-center">
                <div className="text-muted">
                  {t('communication.whatsappTemplate.noTemplatesYet')}
                </div>
                <div className={'mt-5'}>
                  <RedirectToWhatsAppManager locationUUID={locationUUID} />
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div
        ref={footerRef}
        style={{ bottom: '0', zIndex: 100 }}
        className="w-100 d-flex justify-content-between gap-3 rounded-3 align-items-center bg-white py-2 px-3 border-top h-60px bg-white"
      >
        <div
          style={{ marginRight: rightMargin + 'px' }}
          className="d-flex justify-content-end gap-3 align-items-center py-2 w-100 flex-fill"
        >
          <Button
            variant="secondary"
            size="sm"
            onClick={
              selectedTemplate
                ? () => {
                    setSelectedTemplate(null);
                  }
                : () => {
                    dispatch(toggleTemplateModal(false));
                  }
            }
          >
            {t('lomavisCreator.buttons.cancel')}
          </Button>

          {selectedTemplate && (
            <Button
              variant="primary"
              size="sm"
              onClick={() => {
                submitRef.current && submitRef.current?.click();
              }}
              disabled={submitting}
            >
              {submitting && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              {submitting
                ? t('lomavisCreator.buttons.sending')
                : t('lomavisCreator.buttons.send')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhatsappTemplate;
